var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    _vm._l(_vm.msgList, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "item" },
        [
          _c("div", { staticClass: "item-left" }, [
            _c(
              "i",
              {
                staticClass: "el-icon-message-solid",
                staticStyle: { position: "relative" },
              },
              [
                _c("span", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.msg_is_read,
                      expression: "!item.msg_is_read",
                    },
                  ],
                  staticClass: "message-unread",
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-center" }, [
            _c("div", { staticClass: "item-title" }, [
              _vm._v(_vm._s(item.msg_title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-content" }, [
              _vm._v(_vm._s(item.msg_content)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "20px" } }, [
            _vm._v(
              _vm._s(_vm._f("dateFilter")(item.create_date, "yyyy-MM-dd HH:mm"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { padding: "5px", "margin-left": "5px" },
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.ReadClick(item)
                },
              },
            },
            [_vm._v("标记为已读\n    ")]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }